import httpService from '../../../../services/httpService';
import { AdminUserListResponse } from '../interface/adminUserListResponse';

export class AdminUserClient {
  static async getAdminUsers(
    page_number: number = 1,
    limit: number = 25,
    name?: string,
    email?: string
  ): Promise<AdminUserListResponse> {
    const params = new URLSearchParams();
    params.append('page_number', page_number.toString());
    params.append('limit', limit.toString());
    if (name) params.append('name', name);
    if (email) params.append('email', email);

    const response = await httpService.get(`/interview_admin/admin_user/list?${params.toString()}`);
    return response.data;
  }

  static async addAdminUser(full_name: string, email_address: string): Promise<any> {
    const response = await httpService.post(
      `/interview_admin/admin_user/add?email_address=${encodeURIComponent(email_address)}&full_name=${encodeURIComponent(full_name)}`
    );
    return response.data;
  }

  static async viewAdminUser(email_address: string): Promise<any> {
    const response = await httpService.get(
      `/interview_admin/admin_user/view?email_address=${encodeURIComponent(email_address)}`
    );
    return response.data;
  }

  static async editAdminUser(email_address: string, full_name: string): Promise<any> {
    const response = await httpService.post(
      `/interview_admin/admin_user/edit?email_address=${encodeURIComponent(email_address)}`,
      { full_name }
    );
    return response.data;
  }

  static async deleteAdminUser(email_address: string): Promise<any> {
    const response = await httpService.delete(
      `/interview_admin/admin_user/delete?email_address=${encodeURIComponent(email_address)}`
    );
    return response.data;
  }

  static async revokeAdminUserInvite(email_address: string): Promise<any> {
    const response = await httpService.post(
      `/interview_admin/admin_user/revoke?email_address=${encodeURIComponent(email_address)}`
    );
    return response.data;
  }

  static async resendAdminUserInvite(email_address: string): Promise<any> {
    const response = await httpService.post(
      `/interview_admin/admin_user/invite?email_address=${encodeURIComponent(email_address)}`
    );
    return response.data;
  }
}
